/* unplugin-vue-components disabled */import script from "./submitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./submitCard.vue?vue&type=script&setup=true&lang=js"

import "./submitCard.vue?vue&type=style&index=0&id=40859aa5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40859aa5"]])

export default __exports__